/* stylelint-disable selector-class-pattern -- Global classes from react-aria */

.textField {
    --color-invalid: var(--red);
    // input elements don't let you use a value below what `line-height: normal` gives you
    // so the font was bringing too much height. This fixes the problem while letting
    // padding-16 do its thing
    --line-height-adjustment: 0.1875em;
    --padding: calc(var(--spacer-16) - var(--line-height-adjustment));
    --padding-adjustment: 0.25lh;
    --base-font: var(--font-p-16);
    --color-contrast: var(--white);
    --color-primary: var(--navy);

    display: flex;
    flex-direction: column;
    gap: var(--spacer-8);

    &[data-disabled] .fieldWrapper {
        opacity: 0.5;
    }

    :global(.react-aria-FieldError) {
        color: var(--color-invalid);
    }
}

.fieldWrapper {
    composes: contrast from "../../styles/composable/themes.module.css";
    position: relative;
    border-radius: var(--border-radius-sm);

    &:has(input[data-focused="true"]),
    &:has(input[data-hovered="true"]) {
        outline: 1px solid oklch(from currentColor l c h / 30%);
    }

    input {
        background: transparent;
        color: inherit;
        border: none;
        width: 100%;
        height: 100%;
        padding-inline: var(--padding);
        padding-bottom: calc(var(--padding) - var(--padding-adjustment));
        padding-top: calc(var(--padding) + var(--padding-adjustment));
        font: var(--base-font);

        &:focus-visible {
            outline: none;
        }
    }

    label {
        position: absolute;
        left: var(--padding);
        top: var(--padding);
        text-transform: uppercase;

        // 1-off font override!
        font: var(--font-eyebrow-14);
        font-size: 11px;
        letter-spacing: -0.01em;

        // slide on out of the way
        transition:
            translate 0.1s,
            font 0.1s;
        translate: 0 calc(var(--padding) / -2.5);

        /*  move label out of the way of text if:
            1. input (any) is focused
            2. input (text or text area) is not empty
            3. is labeling a dropdown (those always have placeholders)
        */
        &:not(
            :has(
                + :focus-visible,
                + input:not([value=""]),
                + textarea:not(.empty),
                + button
            )
        ) {
            translate: 0;
            text-transform: none;
            font: var(--base-font);
        }

        &:has(+ [required])::after {
            content: "*";
        }
    }
}

.childWrapper {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
}

.loader {
    --fill-color: var(--navy);
    --background-color: var(--pale-navy);

    scale: 50%;
}
